import http, { unwrap } from './http'
import type {
  ApiResp,
  OnlinePayCreateVo,
  QrInvoiceBo,
  QrMpayBo,
  QrPayMethod,
  QrSessionVo,
} from '@/types/qr'

const base = (posMachineCode: string) =>
  `/qr/${encodeURIComponent(posMachineCode)}/session`

export function createSession(posMachineCode: string) {
  return unwrap<QrSessionVo>(http.post<ApiResp<QrSessionVo>>(base(posMachineCode)))
}

export function pollSession(posMachineCode: string, sessionId: string) {
  return unwrap<QrSessionVo>(
    http.get<ApiResp<QrSessionVo>>(`${base(posMachineCode)}/${sessionId}`),
  )
}

export function cancelSession(posMachineCode: string, sessionId: string) {
  return unwrap<QrSessionVo>(
    http.post<ApiResp<QrSessionVo>>(`${base(posMachineCode)}/${sessionId}/cancel`),
  )
}

/** 電子支付通路(如 LINE Pay)導回 confirmUrl 後由前端觸發,server 再向 payment service 完成 confirm */
export function confirmPayment(posMachineCode: string, sessionId: string) {
  return unwrap<QrSessionVo>(
    http.post<ApiResp<QrSessionVo>>(`${base(posMachineCode)}/${sessionId}/pay-confirm`),
  )
}

/** 電子支付通路(如 LINE Pay)導回 cancelUrl 後由前端觸發,server 再向 payment service 完成 cancel */
export function cancelPayment(posMachineCode: string, sessionId: string) {
  return unwrap<QrSessionVo>(
    http.post<ApiResp<QrSessionVo>>(`${base(posMachineCode)}/${sessionId}/pay-cancel`),
  )
}

/** machine-ack 後手機端選付款方式(mpay 電子支付 / cash 現金)。回傳更新後 QrSessionVo(payMethod 已填) */
export function selectPayMethod(
  posMachineCode: string,
  sessionId: string,
  method: QrPayMethod,
) {
  return unwrap<QrSessionVo>(
    http.post<ApiResp<QrSessionVo>>(
      `${base(posMachineCode)}/${sessionId}/pay-method`,
      { method },
    ),
  )
}

export function payByMobile(
  posMachineCode: string,
  sessionId: string,
  body: QrMpayBo,
) {
  return unwrap<OnlinePayCreateVo>(
    http.post<ApiResp<OnlinePayCreateVo>>(
      `${base(posMachineCode)}/${sessionId}/mpay`,
      body,
    ),
  )
}

export function issueInvoice(
  posMachineCode: string,
  sessionId: string,
  body: QrInvoiceBo,
) {
  return unwrap<QrSessionVo>(
    http.post<ApiResp<QrSessionVo>>(
      `${base(posMachineCode)}/${sessionId}/invoice`,
      body,
    ),
  )
}
